import { mapActions } from 'vuex'
import { eventBus } from '@/main'

export default {
    methods: {
        ...mapActions({
            FetchUserDefinedOption: 'userDefinedOption/FetchUserDefinedOption',
            UpdateUserDefinedOption: 'userDefinedOption/UpdateUserDefinedOption',
        }),
        LoadTheme() {
            eventBus.$emit('user-theme-fetch:started');
            this.FetchUserDefinedOption({ Area: 'Theme' })
                .then(response => {
                    response = CoalesceJSON(response);
                    this.useDarkTheme = response?.ThemeVariant == 'dark';
                    eventBus.$emit('user-theme-fetch:success');
                })
                .catch(error => eventBus.$emit('console:error', error))
                .finally(() => eventBus.$emit('user-theme-fetch:finished'));
        },
        SaveTheme() {
            eventBus.$emit('user-theme-save:started');
            this.UpdateUserDefinedOption({
                Area: 'Theme',
                Options: JSON.stringify({ ThemeVariant: this.useDarkTheme ? 'dark' : 'light' })
            })
                .then(response => eventBus.$emit('user-theme-save:success', response))
                .catch(error => eventBus.$emit('console:error', error))
                .finally(() => eventBus.$emit('user-theme-save:finished'));
        }
    },
};
function CoalesceJSON(object, returnObject) {
    if (object == null) return returnObject;
    else if (typeof object == 'object') return object;
    else return JSON.parse(object);
};
